import axios from 'axios'
import type { model, addmodel , modelfilter} from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'model'

export const readModelListAPI = async (modelfilpage: modelfilter): Promise<model[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
      ...modelfilpage
    }
  })
  console.log("readModelListAPI 응답:", response.data)
  return response.data.data
}

export const addModelAPI = async (addModel: addmodel): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'add',
      ...addModel
    }
  })
  console.log("addModelAPI 응답:", response.data)
  return response.data
}

export const updateModelAPI = async (model: model): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      ...model
    }
  })
  console.log("updateModelAPI 응답:", response.data)
  return response.data
}

export const deleteModelAPI = async (id: number): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      id: id,
    }
  })
  console.log("deleteModelAPI 응답:", response.data)
  return response.data
}

export const paginationModelAPI = async (size: number, chipset_id: number): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'pagination',
      size: size,
      chipset_id: chipset_id
    }
  })
  console.log("paginationModelAPI 응답:", response.data)
  return response.data.data.totalpage
}